<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-content width="1100px">
		<kaveh-form :key="ver" :entity="entity" :task="submit" />
	</kaveh-content>
</template>
<script>
	import { NoticePattern } from '@/modules/notification/data/notice-pattern/create'
	import { NoticePatternService } from '@/modules/notification/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed: 
		{
			entity()
			{
				return NoticePattern
			},
			service()
			{
				return new NoticePatternService()
			},
		},
		methods:
		{
			async submit(payload)
			{
				try
				{
					const res = await this.service.create(payload);
					if (res.status == 200)
					{
						this.ver += 1
					}

				} catch (e) { console.log(e) }
			}
		}
	}
</script>